import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/emendations/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllModalities: config.endpoints.backend + 'emendationmodalities/getall',
        endpointGetAllSituations: config.endpoints.backend + 'emendationsituations/getall',
        endpointGetAllGrantors: config.endpoints.backend + 'emendationgrantors/getall',
        endpointGetAllAuthors: config.endpoints.backend + 'emendationauthors/getall',
        endpointGetAllTypes: config.endpoints.backend + 'emendationtypes/getall',
        endpointDelete: `${config.endpoints.backend}emendations/delete`,
        endpoint: config.endpoints.backend + 'emendations/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_project_ids ? {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            {
                name: 'pdc_emendation_modality_id',
                type: 'select',
                label: 'Modalidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllModalities,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_emendation_situation_id',
                type: 'select',
                label: 'Situação',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllSituations,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_emendation_type_id',
                type: 'select',
                label: 'Tipo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_emendation_grantor_id',
                type: 'select',
                label: 'Concedente',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllGrantors,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_emendation_author_id',
                type: 'select',
                label: 'Autor',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllAuthors,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Emendas',
        labelTitleButtonAdd: 'Incluir nova emenda',
        fieldsShowOnDelete: ['type'],
        showPrintButtons: true,
        formFilters: filters,
        filters: {
            ...profileFilter
        },
        columns: [
            {
                name: 'type',
                label: 'Tipo',
            },
            {
                name: 'author',
                label: 'Autor',
            },
            {
                name: 'modality',
                label: 'Modalidade',
            },
            {
                name: 'grantor',
                label: 'Órgão Concedente',
            },
            {
                name: 'start_validity',
                label: 'Início Vigência',
            },
            {
                name: 'end_validity',
                label: 'Fim Vigência',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
